module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v-transfer-dom-296.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/directives/v-transfer-dom.md
// module id = 739
// module chunks = 382